webpackJsonp([91478445319533],{

/***/ 98:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _IconPaths = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Paths
	
	
	var DEBUG = false;
	var NUM_BUBBLES = 5;
	
	var FlaskIcon = function (_React$Component) {
	  _inherits(FlaskIcon, _React$Component);
	
	  function FlaskIcon(props) {
	    _classCallCheck(this, FlaskIcon);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._bubbles = [];
	    _this._icon = null;
	    _this._motionPaths = _lodash2.default.times(NUM_BUBBLES, function () {
	      return null;
	    });
	    return _this;
	  }
	
	  FlaskIcon.prototype._initAnimations = function _initAnimations() {
	    var _this2 = this;
	
	    var startShape = this._icon.querySelector('#liquid-1');
	    var endShape = this._icon.querySelector('#liquid-2');
	
	    var startPathData = startShape.getAttribute('d');
	    var endPathData = endShape.getAttribute('d');
	
	    TweenMax.to(startShape, 1, {
	      morphSVG: endPathData,
	      // ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true,
	      force3D: true
	    });
	
	    _lodash2.default.times(NUM_BUBBLES, function (i) {
	      var bezierData = MorphSVGPlugin.pathDataToBezier(_this2._motionPaths[i], {
	        align: _this2._bubbles[i]
	      });
	      TweenMax.set(_this2._bubbles[i], { xPercent: -50, yPercent: -50 });
	      TweenMax.to(_this2._bubbles[i], 2, {
	        opacity: 0,
	        bezier: {
	          values: bezierData,
	          type: 'cubic'
	        },
	        ease: Linear.easeNone,
	        repeat: -1,
	        yoyo: false,
	        delay: 0.4 * i
	      });
	    });
	  };
	
	  FlaskIcon.prototype.componentDidMount = function componentDidMount() {
	    this._initAnimations();
	  };
	
	  FlaskIcon.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        colors = _props.colors,
	        height = _props.height,
	        width = _props.width;
	
	    var baseIconColor = colors.length > 1 ? colors[1] : colors[0];
	    var bubbleColor = colors[0];
	    return _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 100 100', width: width, height: height },
	      _react2.default.createElement(
	        'g',
	        { ref: function ref(icon) {
	            _this3._icon = icon;
	          } },
	        _react2.default.createElement(_IconPaths.Flask, { transform: 'translate(0, 20)', liquidColor: baseIconColor })
	      ),
	      _react2.default.createElement(
	        'g',
	        null,
	        _lodash2.default.times(NUM_BUBBLES, function (i) {
	          return _react2.default.createElement('circle', {
	            key: 'bubble-' + i,
	            ref: function ref(bubble) {
	              _this3._bubbles[i] = bubble;
	            },
	            cx: 0,
	            cy: 0,
	            r: NUM_BUBBLES - i,
	            fill: bubbleColor,
	            stroke: 'white' });
	        })
	      ),
	      _lodash2.default.times(NUM_BUBBLES, function (i) {
	        var stretchfactor = 20 * i / NUM_BUBBLES;
	        return _react2.default.createElement('path', {
	          key: 'motionPath-' + i,
	          ref: function ref(motionPath) {
	            _this3._motionPaths[i] = motionPath;
	          },
	          d: 'M 50,75 C ' + (50 - stretchfactor) + ',50 ' + (50 + stretchfactor) + ',25 50,5',
	          stroke: DEBUG ? 'cornflowerblue' : 'none',
	          fill: 'none' });
	      })
	    );
	  };
	
	  return FlaskIcon;
	}(_react2.default.Component);
	
	;
	
	FlaskIcon.propTypes = {
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number
	};
	
	FlaskIcon.defaultProps = {
	  colors: ['black'],
	  width: 200,
	  height: 200
	};
	
	exports.default = FlaskIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _IconPaths = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Paths
	
	
	var HeartIcon = function (_React$Component) {
	  _inherits(HeartIcon, _React$Component);
	
	  function HeartIcon(props) {
	    _classCallCheck(this, HeartIcon);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._icon = null;
	    return _this;
	  }
	
	  HeartIcon.prototype._initAnimations = function _initAnimations() {
	    TweenMax.to(this._icon, 0.2, {
	      scale: 1.1,
	      transformOrigin: '50% 50%',
	      ease: Power2.easeInOut,
	      repeat: 10,
	      yoyo: true
	    });
	  };
	
	  HeartIcon.prototype.componentDidMount = function componentDidMount() {
	    this._initAnimations();
	  };
	
	  HeartIcon.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        color = _props.color,
	        height = _props.height,
	        width = _props.width;
	
	    return _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 100 100', width: width, height: height },
	      _react2.default.createElement(
	        'g',
	        { ref: function ref(icon) {
	            _this2._icon = icon;
	          } },
	        _react2.default.createElement(_IconPaths.Heart, { strokeColor: color, transform: 'translate(0, 0)' })
	      )
	    );
	  };
	
	  return HeartIcon;
	}(_react2.default.Component);
	
	;
	
	HeartIcon.propTypes = {
	  color: _propTypes2.default.string,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number
	};
	
	HeartIcon.defaultProps = {
	  color: 'black',
	  width: 200,
	  height: 200
	};
	
	exports.default = HeartIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Flask = exports.Podium = exports.Munch = exports.Heart = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Heart = exports.Heart = function Heart(_ref) {
	  var _ref$strokeColor = _ref.strokeColor,
	      strokeColor = _ref$strokeColor === undefined ? 'black' : _ref$strokeColor,
	      transform = _ref.transform;
	  return _react2.default.createElement(
	    'g',
	    { transform: transform },
	    _react2.default.createElement('path', {
	      fill: 'none',
	      stroke: strokeColor,
	      strokeWidth: 1,
	      d: 'M50.002,20.532C29.919-3.799-12.5,21.679,12.851,57.393c10.002,14.08,37.151,31.672,37.151,31.672  c0.013-0.01,27.145-17.592,37.147-31.672C112.5,21.679,70.081-3.799,50.002,20.532z' })
	  );
	};
	
	var Munch = exports.Munch = function Munch(_ref2) {
	  var _ref2$strokeColor = _ref2.strokeColor,
	      strokeColor = _ref2$strokeColor === undefined ? 'black' : _ref2$strokeColor,
	      transform = _ref2.transform;
	  return _react2.default.createElement(
	    'g',
	    { transform: transform },
	    _react2.default.createElement(
	      'g',
	      null,
	      _react2.default.createElement('path', { id: 'lip-top', d: '\n      M 20 50\n      C 20 70, 80 70, 80 50\n      ', stroke: strokeColor, strokeLinecap: 'round', strokeWidth: 2, fill: 'none' }),
	      _react2.default.createElement('path', { id: 'lip-bottom', d: '\n        M 20 50\n        C 20 60, 80 60, 80 50\n        ', stroke: strokeColor, strokeLinecap: 'round', strokeWidth: 2, fill: 'none' }),
	      _react2.default.createElement('path', { id: 'mouth-closed', d: '\n        M 20 50\n        C 20 60, 80 65, 80 50\n        ', stroke: 'none', fill: 'none' }),
	      _react2.default.createElement('path', { id: 'cheek-left', d: '\n        M 20 45\n        q 0 12, -4 15\n        ', stroke: strokeColor, strokeLinecap: 'round', strokeWidth: 2, fill: 'none' }),
	      _react2.default.createElement('path', { id: 'cheek-left-a', d: '\n        M 20 40\n        q 2 12, -8 20\n        ', stroke: 'none', strokeLinecap: 'round', strokeWidth: 2, fill: 'none' }),
	      _react2.default.createElement('path', { id: 'cheek-right', d: '\n        M 80 45\n        q 0 12, 4 15\n        ', stroke: strokeColor, strokeLinecap: 'round', strokeWidth: 2, fill: 'none' }),
	      _react2.default.createElement('path', { id: 'cheek-right-a', d: '\n        M 80 40\n        q -2 12, 8 20\n        ', stroke: 'none', fill: 'none' })
	    ),
	    _react2.default.createElement(
	      'g',
	      null,
	      _react2.default.createElement('path', { id: 'motion-path-1', d: '\n        M 90 100\n        q 0 -30 -40 -40\n      ', stroke: 'none', fill: 'none' }),
	      _react2.default.createElement('path', { id: 'motion-path-2', d: '\n        M 10 100\n        q 0 -30 40 -40\n      ', stroke: 'none', fill: 'none' })
	    )
	  );
	};
	
	var Podium = exports.Podium = function Podium(_ref3) {
	  var transform = _ref3.transform,
	      _ref3$strokeColor = _ref3.strokeColor,
	      strokeColor = _ref3$strokeColor === undefined ? 'white' : _ref3$strokeColor,
	      _ref3$fill = _ref3.fill,
	      fill = _ref3$fill === undefined ? 'black' : _ref3$fill,
	      _ref3$nodeColors = _ref3.nodeColors,
	      nodeColors = _ref3$nodeColors === undefined ? ['black', 'black', 'black'] : _ref3$nodeColors;
	  return _react2.default.createElement(
	    'g',
	    { transform: transform },
	    _react2.default.createElement(
	      'g',
	      null,
	      _react2.default.createElement('path', { id: 'podium-rect-1', d: '\n        M 0 71\n        q 0 -5, 5 -5\n        c 3 0, 6 0, 9 0\n        c 3 0, 6 0, 9 0\n        q 5 0,5 5 v 29 h -28 Z\n        ', fill: fill }),
	      _react2.default.createElement('path', { id: 'podium-rect-1a', d: '\n        M 0 71\n        q 0 -5, 5 -5\n        c 3 0, 6 3, 9 3\n        c 3 0, 6 -3, 9 -3\n        q 5 0,5 5 v 29 h -28 Z\n        ', fill: 'none' }),
	      _react2.default.createElement('path', { id: 'podium-rect-2', d: '\n        M 36 65\n        q 0 -5, 5 -5\n        c 3 0, 6 0, 9 0\n        c 3 0, 6 0, 9 0\n        q 5 0,5 5\n        v 35 h -28 Z\n      ', fill: fill }),
	      _react2.default.createElement('path', { id: 'podium-rect-2a', d: '\n        M 36 65\n        q 0 -5, 5 -5\n        c 3 0, 6 3, 9 3\n        c 3 0, 6 -3, 9 -3\n        q 5 0,5 5\n        v 35 h -28 Z\n      ', fill: 'none' }),
	      _react2.default.createElement('path', { id: 'podium-rect-3', d: '\n        M 72 81\n        q 0 -5, 5 -5\n        c 3 0, 6 0, 9 0\n        c 3 0, 6 0, 9 0\n        q 5 0,5 5\n        v 29 h -28 Z\n      ', fill: fill }),
	      _react2.default.createElement('path', { id: 'podium-rect-3a', d: '\n        M 72 81\n        q 0 -5, 5 -5\n        c 3 0, 6 3, 9 3\n        c 3 0, 6 -3, 9 -3\n        q 5 0,5 5\n        v 29 h -28 Z\n      ', fill: 'none' })
	    ),
	    _react2.default.createElement(
	      'g',
	      null,
	      _react2.default.createElement('circle', { id: 'podium-circle-1', stroke: strokeColor, strokeWidth: 1, fill: nodeColors[0], r: 8, cx: 14, cy: 56 }),
	      _react2.default.createElement('circle', { id: 'podium-circle-2', stroke: strokeColor, strokeWidth: 1, fill: nodeColors[1], r: 10, cx: 50, cy: 50 }),
	      _react2.default.createElement('circle', { id: 'podium-circle-3', stroke: strokeColor, strokeWidth: 1, fill: nodeColors[2], r: 7, cx: 86, cy: 66 })
	    )
	  );
	};
	var Flask = exports.Flask = function Flask(_ref4) {
	  var transform = _ref4.transform,
	      _ref4$liquidColor = _ref4.liquidColor,
	      liquidColor = _ref4$liquidColor === undefined ? 'black' : _ref4$liquidColor,
	      _ref4$flaskColor = _ref4.flaskColor,
	      flaskColor = _ref4$flaskColor === undefined ? 'black' : _ref4$flaskColor;
	  return _react2.default.createElement(
	    'g',
	    { transform: transform },
	    _react2.default.createElement('path', { id: 'liquid-1', d: 'M 67.771 67.945 L 57.605 53.427 C 55,58 45,48 42.395 53.427 L 32.229 67.945 c 0 0 -2.762 3.762 2.562 3.762 c 5.604 0 15.209 0 15.209 0 s 9.604 0 15.209 0 C 70.532 71.707 67.771 67.945 67.771 67.945 z', fill: liquidColor }),
	    _react2.default.createElement('path', { id: 'liquid-2', d: 'M 67.771 67.945 L 57.605 53.427 C 55,48 45,58 42.395 53.427 L 32.229 67.945 c 0 0 -2.762 3.762 2.562 3.762 c 5.604 0 15.209 0 15.209 0 s 9.604 0 15.209 0 C 70.532 71.707 67.771 67.945 67.771 67.945 z', fill: 'none' }),
	    _react2.default.createElement('path', { d: 'M69,75H31.002c-2,0-3.29-0.557-3.835-1.656c-1.115-2.252,1.473-5.755,1.771-6.146L44.17,45.012V25.5h1v19.822    L29.748,67.783c-0.721,0.949-2.398,3.677-1.685,5.118C28.426,73.63,29.414,74,31.002,74H69c1.588,0,2.576-0.37,2.938-1.099    c0.714-1.441-0.964-4.169-1.67-5.099l-15.437-22.48V25.5h1v19.512l15.246,22.205c0.284,0.372,2.872,3.875,1.757,6.127    C72.29,74.443,71,75,69,75z', fill: flaskColor })
	  );
	};

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEBUG = false;
	var ANIM_DURATION = 2;
	var NUM_ATOMS_PER_RING = 2;
	var NUM_RINGS = 3;
	
	var MoleculeIcon = function (_React$Component) {
	  _inherits(MoleculeIcon, _React$Component);
	
	  function MoleculeIcon(props) {
	    _classCallCheck(this, MoleculeIcon);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._icon = null;
	    _this._motionPaths = _lodash2.default.times(NUM_RINGS, function () {
	      return null;
	    });
	    _this._atoms = _lodash2.default.times(6, function () {
	      return null;
	    });
	    return _this;
	  }
	
	  MoleculeIcon.prototype._initAnimations = function _initAnimations() {
	    var _this2 = this;
	
	    this._motionPaths.forEach(function (mp, i) {
	      var pathData = mp.getAttribute('d');
	
	      var index1 = i * 2;
	      var index2 = i * 2 + 1;
	      var atoms = [_this2._atoms[index1], _this2._atoms[index2]];
	
	      var bezierData = MorphSVGPlugin.pathDataToBezier(pathData, { align: atoms });
	
	      TweenMax.set(atoms, {
	        xPercent: -50,
	        yPercent: -50,
	        opacity: 1,
	        bezier: {
	          values: bezierData,
	          type: 'cubic'
	        }
	      });
	
	      _lodash2.default.times(NUM_ATOMS_PER_RING, function (j) {
	        TweenMax.to(atoms[j], ANIM_DURATION, {
	          bezier: {
	            values: bezierData,
	            type: 'cubic'
	          },
	          ease: Linear.easeNone,
	          repeat: -1,
	          yoyo: false,
	          delay: ANIM_DURATION * 0.5 * j + index1 * 0.2
	        });
	      });
	    });
	  };
	
	  MoleculeIcon.prototype.componentDidMount = function componentDidMount() {
	    this._initAnimations();
	  };
	
	  MoleculeIcon.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        centerColor = _props.centerColor,
	        electronColor = _props.electronColor,
	        ringColor = _props.ringColor,
	        width = _props.width,
	        height = _props.height;
	
	
	    return _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 100 100', width: width, height: height },
	      _react2.default.createElement(
	        'g',
	        { ref: function ref(icon) {
	            _this3._icon = icon;
	          } },
	        _react2.default.createElement('circle', {
	          ref: function ref(center) {
	            _this3._center = center;
	          },
	          r: 3,
	          cx: 50,
	          cy: 50,
	          fill: centerColor })
	      ),
	      _react2.default.createElement(
	        'g',
	        null,
	        _lodash2.default.times(NUM_RINGS, function (i) {
	          return _react2.default.createElement('path', {
	            key: 'motion-path-' + i,
	            style: {
	              transform: 'rotate(' + i * 180 / NUM_RINGS + 'deg)',
	              transformOrigin: '50% 50%'
	            },
	            ref: function ref(motionPath) {
	              _this3._motionPaths[i] = motionPath;
	            },
	            d: 'M 5 50 c 5 -20, 95 -20, 90 0 s -90 20, -90 0',
	            fill: 'none',
	            opacity: 0.2,
	            stroke: ringColor,
	            strokeWidth: 1 });
	        })
	      ),
	      _react2.default.createElement(
	        'g',
	        null,
	        _lodash2.default.times(NUM_RINGS, function (i) {
	          return _react2.default.createElement(
	            'g',
	            { key: 'atom-ring-' + i, transform: 'rotate(' + i * 180 / NUM_RINGS + ', 50, 50)' },
	            _lodash2.default.times(NUM_ATOMS_PER_RING, function (j) {
	              return _react2.default.createElement('circle', {
	                key: 'atom-' + i + '__' + j,
	                style: { opacity: 0 },
	                ref: function ref(atom) {
	                  _this3._atoms[i * NUM_ATOMS_PER_RING + j] = atom;
	                },
	                r: 2,
	                cx: 5,
	                cy: 50,
	                fill: electronColor });
	            })
	          );
	        })
	      )
	    );
	  };
	
	  return MoleculeIcon;
	}(_react2.default.Component);
	
	;
	
	MoleculeIcon.propTypes = {
	  centerColor: _propTypes2.default.string,
	  electronColor: _propTypes2.default.string,
	  ringColor: _propTypes2.default.string,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number
	};
	
	MoleculeIcon.defaultProps = {
	  centerColor: 'black',
	  electronColor: 'black',
	  ringColor: 'black',
	  width: 200,
	  height: 200
	};
	
	exports.default = MoleculeIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _IconPaths = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Paths
	
	
	var ANIM_DURATION = 0.4;
	
	var MunchIcon = function (_React$Component) {
	  _inherits(MunchIcon, _React$Component);
	
	  function MunchIcon(props) {
	    _classCallCheck(this, MunchIcon);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._icon = null;
	    _this._motionPaths = [null, null, null];
	    _this._food = [null, null, null];
	    return _this;
	  }
	
	  MunchIcon.prototype._initAnimations = function _initAnimations() {
	    var _this2 = this;
	
	    var topLip = this._icon.querySelector('#lip-top');
	    var bottomLip = this._icon.querySelector('#lip-bottom');
	    var leftCheek = this._icon.querySelector('#cheek-left');
	    var rightCheek = this._icon.querySelector('#cheek-right');
	
	    var mouseClosedData = this._icon.querySelector('#mouth-closed').getAttribute('d');
	    var leftCheekMunchData = this._icon.querySelector('#cheek-left-a').getAttribute('d');
	    var rightCheekMunchData = this._icon.querySelector('#cheek-right-a').getAttribute('d');
	
	    this._motionPaths[0] = this._icon.querySelector('#motion-path-1').getAttribute('d');
	    this._motionPaths[1] = this._icon.querySelector('#motion-path-2').getAttribute('d');
	
	    TweenMax.to(topLip, ANIM_DURATION, {
	      morphSVG: mouseClosedData,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true
	    });
	
	    TweenMax.to(bottomLip, ANIM_DURATION, {
	      morphSVG: mouseClosedData,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true
	    });
	
	    TweenMax.to(leftCheek, ANIM_DURATION, {
	      morphSVG: leftCheekMunchData,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true
	    });
	
	    TweenMax.to(rightCheek, ANIM_DURATION, {
	      morphSVG: rightCheekMunchData,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true
	    });
	
	    _lodash2.default.times(2, function (i) {
	      var bezierData = MorphSVGPlugin.pathDataToBezier(_this2._motionPaths[i], {
	        align: _this2._food[i]
	      });
	      TweenMax.set(_this2._food[i], { xPercent: -50, yPercent: -50 });
	      TweenMax.to(_this2._food[i], ANIM_DURATION * 2, {
	        scale: 0.5,
	        bezier: {
	          values: bezierData,
	          type: 'cubic'
	        },
	        ease: Linear.easeNone,
	        repeat: -1,
	        yoyo: false,
	        delay: 0.1 * i
	      });
	    });
	  };
	
	  MunchIcon.prototype.componentDidMount = function componentDidMount() {
	    this._initAnimations();
	  };
	
	  MunchIcon.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        foodColor = _props.foodColor,
	        strokeColor = _props.strokeColor,
	        width = _props.width,
	        height = _props.height;
	
	
	    return _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 100 100', width: width, height: height },
	      _react2.default.createElement(
	        'g',
	        { ref: function ref(icon) {
	            _this3._icon = icon;
	          } },
	        _react2.default.createElement(_IconPaths.Munch, { transform: 'translate(0, 0)', strokeColor: strokeColor })
	      ),
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement('circle', { ref: function ref(food) {
	            _this3._food[0] = food;
	          }, r: 3, cx: 70, cy: 100, fill: 'none', stroke: foodColor, strokeWidth: 2 }),
	        _react2.default.createElement('circle', { ref: function ref(food) {
	            _this3._food[1] = food;
	          }, r: 2, cx: 70, cy: 100, fill: 'none', stroke: foodColor, strokeWidth: 2 })
	      )
	    );
	  };
	
	  return MunchIcon;
	}(_react2.default.Component);
	
	;
	
	MunchIcon.propTypes = {
	  foodColor: _propTypes2.default.string,
	  strokeColor: _propTypes2.default.string,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number
	};
	
	MunchIcon.defaultProps = {
	  foodColor: 'black',
	  strokeColor: 'black',
	  width: 200,
	  height: 200
	};
	
	exports.default = MunchIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _IconPaths = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Paths
	
	
	var DEBUG = false;
	
	var PodiumIcon = function (_React$Component) {
	  _inherits(PodiumIcon, _React$Component);
	
	  function PodiumIcon(props) {
	    _classCallCheck(this, PodiumIcon);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._icon = null;
	    return _this;
	  }
	
	  PodiumIcon.prototype._initAnimations = function _initAnimations() {
	
	    var circle1 = this._icon.querySelector('#podium-circle-1');
	    var circle2 = this._icon.querySelector('#podium-circle-2');
	    var circle3 = this._icon.querySelector('#podium-circle-3');
	
	    var rect1 = this._icon.querySelector('#podium-rect-1');
	    var rect2 = this._icon.querySelector('#podium-rect-2');
	    var rect3 = this._icon.querySelector('#podium-rect-3');
	
	    var rect1EndData = this._icon.querySelector('#podium-rect-1a').getAttribute('d');
	    var rect2EndData = this._icon.querySelector('#podium-rect-2a').getAttribute('d');
	    var rect3EndData = this._icon.querySelector('#podium-rect-3a').getAttribute('d');
	
	    TweenMax.to(rect1, 0.5, {
	      morphSVG: rect1EndData,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true,
	      delay: 0.5
	    });
	
	    TweenMax.to(rect2, 0.5, {
	      morphSVG: rect2EndData,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true,
	      delay: 0.5
	    });
	
	    TweenMax.to(rect3, 0.5, {
	      morphSVG: rect3EndData,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true,
	      delay: 0.5
	    });
	
	    TweenMax.set(circle1, { scaleY: 0.9, y: 3 });
	    TweenMax.to(circle1, 0.5, {
	      y: -10,
	      scaleY: 1,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true
	    });
	
	    TweenMax.set(circle2, { scaleY: 0.85, y: 0 });
	    TweenMax.to(circle2, 0.5, {
	      y: -20,
	      scaleY: 1,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true
	    });
	
	    TweenMax.set(circle3, { scaleY: 0.9, y: 4 });
	    TweenMax.to(circle3, 0.5, {
	      y: -5,
	      scaleY: 1,
	      ease: Power2.easeInOut,
	      repeat: -1,
	      yoyo: true
	    });
	  };
	
	  PodiumIcon.prototype.componentDidMount = function componentDidMount() {
	    this._initAnimations();
	  };
	
	  PodiumIcon.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        colors = _props.colors,
	        height = _props.height,
	        width = _props.width,
	        nodeColors = _props.nodeColors,
	        strokeColor = _props.strokeColor;
	
	    var baseIconColor = colors.length > 1 ? colors[1] : colors[0];
	
	    return _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 100 100', width: width, height: height },
	      _react2.default.createElement(
	        'g',
	        { ref: function ref(icon) {
	            _this2._icon = icon;
	          } },
	        _react2.default.createElement(_IconPaths.Podium, { transform: 'translate(0, 0)', fill: baseIconColor, nodeColors: nodeColors, strokeColor: strokeColor })
	      )
	    );
	  };
	
	  return PodiumIcon;
	}(_react2.default.Component);
	
	;
	
	PodiumIcon.propTypes = {
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  nodeColors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  strokeColor: _propTypes2.default.string,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number
	};
	
	PodiumIcon.defaultProps = {
	  colors: ['black'],
	  nodeColors: ['black', 'black', 'black'],
	  strokeColor: 'white',
	  width: 200,
	  height: 200
	};
	
	exports.default = PodiumIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PodiumIcon = exports.MunchIcon = exports.MoleculeIcon = exports.HeartIcon = exports.FlaskIcon = undefined;
	
	var _FlaskIcon = __webpack_require__(64);
	
	var _FlaskIcon2 = _interopRequireDefault(_FlaskIcon);
	
	var _HeartIcon = __webpack_require__(65);
	
	var _HeartIcon2 = _interopRequireDefault(_HeartIcon);
	
	var _MunchIcon = __webpack_require__(67);
	
	var _MunchIcon2 = _interopRequireDefault(_MunchIcon);
	
	var _PodiumIcon = __webpack_require__(68);
	
	var _PodiumIcon2 = _interopRequireDefault(_PodiumIcon);
	
	var _MoleculeIcon = __webpack_require__(66);
	
	var _MoleculeIcon2 = _interopRequireDefault(_MoleculeIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.FlaskIcon = _FlaskIcon2.default;
	exports.HeartIcon = _HeartIcon2.default;
	exports.MoleculeIcon = _MoleculeIcon2.default;
	exports.MunchIcon = _MunchIcon2.default;
	exports.PodiumIcon = _PodiumIcon2.default;

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _config = __webpack_require__(17);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Search = __webpack_require__(78);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Logo = __webpack_require__(37);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _HeaderStyles = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var light = _ref.light;
	  return _react2.default.createElement(
	    _HeaderStyles.StyledHeader,
	    null,
	    !light && _react2.default.createElement(
	      _HeaderStyles.HeadingWrap,
	      null,
	      _react2.default.createElement(
	        _HeaderStyles.Heading,
	        null,
	        _react2.default.createElement(_Logo2.default, { size: 32 }),
	        'toomanykiwis'
	      ),
	      _react2.default.createElement(
	        _HeaderStyles.TagLine,
	        null,
	        _config2.default.TAG_LINE
	      )
	    ),
	    _react2.default.createElement(_Search2.default, null)
	  );
	};
	
	// Components
	
	
	Header.propsTypes = {
	  light: _propTypes2.default.bool
	};
	
	Header.defaultProps = {
	  light: true
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HeadingWrap = exports.TagLine = exports.Heading = exports.StyledHeader = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  padding: 1rem 2rem;\n  position: relative;\n'], ['\n  width: 100%;\n  padding: 1rem 2rem;\n  position: relative;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  justify-content: flex-start;\n  display: flex;\n  align-items: center;\n  font-size: 4rem;\n\n  > span {\n    font-size: 2rem;\n    position: relative;\n    top: 6px;\n    left: 1px;\n  }\n\n  > div {\n    margin: 0 8px 0 0;\n    display: inline-block;\n    position: relative;\n\n    > svg {\n      position: absolute;\n      top: 0;\n      left: 0;\n    }\n  }\n'], ['\n  justify-content: flex-start;\n  display: flex;\n  align-items: center;\n  font-size: 4rem;\n\n  > span {\n    font-size: 2rem;\n    position: relative;\n    top: 6px;\n    left: 1px;\n  }\n\n  > div {\n    margin: 0 8px 0 0;\n    display: inline-block;\n    position: relative;\n\n    > svg {\n      position: absolute;\n      top: 0;\n      left: 0;\n    }\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin: 0 0 0 3.9rem;\n'], ['\n  margin: 0 0 0 3.9rem;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  padding: 1rem 0 2rem;\n'], ['\n  padding: 1rem 0 2rem;\n']);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledHeader = exports.StyledHeader = _styledComponents2.default.header(_templateObject);
	
	var Heading = exports.Heading = _styledComponents2.default.h1(_templateObject2);
	
	var TagLine = exports.TagLine = _styledComponents2.default.p(_templateObject3);
	
	var HeadingWrap = exports.HeadingWrap = _styledComponents2.default.hgroup(_templateObject4);

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Header = __webpack_require__(43);
	
	var _Header2 = _interopRequireDefault(_Header);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Header2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LeaderboardItem = __webpack_require__(77);
	
	var _LeaderboardItem2 = _interopRequireDefault(_LeaderboardItem);
	
	var _materialUiIcons = __webpack_require__(60);
	
	var _utils = __webpack_require__(18);
	
	var _LeaderboardStyles = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	// Icons
	
	
	// Utils
	
	
	// Styles
	
	
	var Leaderboard = function (_React$Component) {
	  _inherits(Leaderboard, _React$Component);
	
	  function Leaderboard(props) {
	    _classCallCheck(this, Leaderboard);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      descriptionExpanded: false,
	      listCollapsed: true
	    };
	    _this._handleMoreTapped = _this._handleMoreTapped.bind(_this);
	    _this._handleExpandDescriptionTapped = _this._handleExpandDescriptionTapped.bind(_this);
	    return _this;
	  }
	
	  Leaderboard.prototype._handleMoreTapped = function _handleMoreTapped() {
	    this.setState({
	      listCollapsed: !this.state.listCollapsed
	    });
	  };
	
	  Leaderboard.prototype._handleExpandDescriptionTapped = function _handleExpandDescriptionTapped() {
	    this.setState({
	      descriptionExpanded: !this.state.descriptionExpanded
	    });
	  };
	
	  Leaderboard.prototype.render = function render() {
	    var _state = this.state,
	        listCollapsed = _state.listCollapsed,
	        descriptionExpanded = _state.descriptionExpanded;
	    var _props = this.props,
	        collapseAfter = _props.collapseAfter,
	        items = _props.items,
	        split = _props.split,
	        title = _props.title,
	        description = _props.description;
	
	    return _react2.default.createElement(
	      _LeaderboardStyles.Wrapper,
	      { className: split ? '--split' : '' },
	      _react2.default.createElement(
	        _LeaderboardStyles.LeaderboardWrapper,
	        null,
	        _react2.default.createElement(
	          _LeaderboardStyles.Header,
	          null,
	          title,
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { title: 'Click to read a description of this list', onClick: this._handleExpandDescriptionTapped },
	            _react2.default.createElement(_materialUiIcons.HelpOutline, { style: { color: 'inherit', width: 20, height: 20 } })
	          )
	        ),
	        _react2.default.createElement(
	          _LeaderboardStyles.Description,
	          { show: descriptionExpanded },
	          description
	        ),
	        _react2.default.createElement(
	          _LeaderboardStyles.List,
	          null,
	          items.map(function (item, i) {
	            return (!listCollapsed || i < collapseAfter) && _react2.default.createElement(_LeaderboardItem2.default, {
	              key: 'leaderboard-item-' + i,
	              index: i + 1,
	              title: item.title,
	              meta: item.meta,
	              slug: (0, _utils.createSlugFromTitle)(item.title) });
	          }),
	          collapseAfter < items.length && _react2.default.createElement(
	            _LeaderboardStyles.Expander,
	            { onClick: this._handleMoreTapped },
	            listCollapsed ? 'More' : 'Less'
	          )
	        )
	      )
	    );
	  };
	
	  return Leaderboard;
	}(_react2.default.Component);
	
	;
	
	Leaderboard.propTypes = {
	  items: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  title: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string,
	  collapseAfter: _propTypes2.default.number,
	  split: _propTypes2.default.bool
	};
	
	Leaderboard.defaultProps = {
	  collapseAfter: 10,
	  description: '',
	  split: false
	};
	
	exports.default = Leaderboard;
	module.exports = exports['default'];

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Expander = exports.List = exports.Description = exports.Header = exports.LeaderboardWrapper = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  text-align: left;\n\n  &.--split {\n    ', '\n    ', '\n    ', '\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  text-align: left;\n\n  &.--split {\n    ', '\n    ', '\n    ', '\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['width: 50%;'], ['width: 50%;']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['width: 25%;'], ['width: 25%;']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['width: 20%;'], ['width: 20%;']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  margin: 1rem;\n  border-radius: 5px;\n  overflow: hidden;\n'], ['\n  margin: 1rem;\n  border-radius: 5px;\n  overflow: hidden;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  margin: 0;\n  padding: 3.2rem 15px 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  position: relative;\n\n  > a {\n    position: absolute;\n    top: 3rem;\n    right: 0.5rem;\n    opacity: 0.2;\n    cursor: pointer;\n    display: none;\n    ', '\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n'], ['\n  width: 100%;\n  margin: 0;\n  padding: 3.2rem 15px 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  position: relative;\n\n  > a {\n    position: absolute;\n    top: 3rem;\n    right: 0.5rem;\n    opacity: 0.2;\n    cursor: pointer;\n    display: none;\n    ', '\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['display: inline-block;'], ['display: inline-block;']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n\n  display: block;\n  ', '\n  padding: 0 1.5rem 1rem;\n  font-size: 1.4rem;\n'], ['\n\n  display: block;\n  ', '\n  padding: 0 1.5rem 1rem;\n  font-size: 1.4rem;\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['display: ', ';'], ['display: ', ';']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  border-left: 1px solid rgba(0, 0, 0, 0.85);\n'], ['\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  border-left: 1px solid rgba(0, 0, 0, 0.85);\n']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  height: 40px;\n  padding: 5px 50px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n'], ['\n  width: 100%;\n  height: 40px;\n  padding: 5px 50px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n']);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styleUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.div(_templateObject, _styleUtils.media.fromSmall(_templateObject2), _styleUtils.media.fromLarge(_templateObject3), _styleUtils.media.fromXLarge(_templateObject4));
	
	var LeaderboardWrapper = exports.LeaderboardWrapper = _styledComponents2.default.div(_templateObject5);
	
	var Header = exports.Header = _styledComponents2.default.h2(_templateObject6, _styleUtils.media.fromSmall(_templateObject7));
	
	var Description = exports.Description = _styledComponents2.default.p(_templateObject8, _styleUtils.media.fromSmall(_templateObject9, function (props) {
	  return props.show ? 'block' : 'none';
	}));
	
	var List = exports.List = _styledComponents2.default.ul(_templateObject10);
	
	var Expander = exports.Expander = _styledComponents2.default.a(_templateObject11);

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Leaderboard = __webpack_require__(72);
	
	var _Leaderboard2 = _interopRequireDefault(_Leaderboard);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Leaderboard2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LeaderboardItemStyles = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LeaderboardItem = function LeaderboardItem(_ref) {
	  var index = _ref.index,
	      meta = _ref.meta,
	      slug = _ref.slug,
	      title = _ref.title;
	  return _react2.default.createElement(
	    _LeaderboardItemStyles.Wrapper,
	    null,
	    _react2.default.createElement(
	      _LeaderboardItemStyles.Index,
	      null,
	      index
	    ),
	    _react2.default.createElement(
	      _LeaderboardItemStyles.Label,
	      null,
	      slug ? _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' + slug + '/' },
	        title
	      ) : title,
	      meta && _react2.default.createElement(
	        _LeaderboardItemStyles.Meta,
	        null,
	        meta
	      )
	    )
	  );
	};
	
	// Styles
	
	
	LeaderboardItem.propTypes = {
	  index: _propTypes2.default.number.isRequired,
	  meta: _propTypes2.default.string,
	  title: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string,
	  slug: _propTypes2.default.string
	};
	
	LeaderboardItem.defaultProps = {
	  description: '',
	  slug: '',
	  meta: null
	};
	
	exports.default = LeaderboardItem;
	module.exports = exports['default'];

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Meta = exports.Label = exports.Index = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n'], ['\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 50px;\n  height: 100%;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  width: 50px;\n  height: 100%;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: inline-flex;\n  width: 100%;\n  padding: 5px;\n  height: 100%;\n  justify-content: flex-start;\n  align-items: center;\n  position: relative;\n'], ['\n  display: inline-flex;\n  width: 100%;\n  padding: 5px;\n  height: 100%;\n  justify-content: flex-start;\n  align-items: center;\n  position: relative;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  color: green;\n  position: absolute;\n  right: 0;\n'], ['\n  color: green;\n  position: absolute;\n  right: 0;\n']);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.li(_templateObject);
	
	var Index = exports.Index = _styledComponents2.default.div(_templateObject2);
	
	var Label = exports.Label = _styledComponents2.default.div(_templateObject3);
	
	var Meta = exports.Meta = _styledComponents2.default.span(_templateObject4);

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _LeaderboardItem = __webpack_require__(75);
	
	var _LeaderboardItem2 = _interopRequireDefault(_LeaderboardItem);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _LeaderboardItem2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(272);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _reactHelmet = __webpack_require__(33);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Header = __webpack_require__(45);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Leaderboard = __webpack_require__(74);
	
	var _Leaderboard2 = _interopRequireDefault(_Leaderboard);
	
	var _AnimatedIcons = __webpack_require__(41);
	
	var _utils = __webpack_require__(18);
	
	var _NutrientTemplateStyles = __webpack_require__(330);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	function Template(_ref) {
	  var pathContext = _ref.pathContext,
	      data = _ref.data;
	  var markdownRemark = data.markdownRemark; // data.markdownRemark holds our post data
	
	  var frontmatter = markdownRemark.frontmatter,
	      html = markdownRemark.html;
	  var altname = frontmatter.altname,
	      path = frontmatter.path,
	      name = frontmatter.name,
	      tags = frontmatter.tags;
	  var topFoods = pathContext.topFoods;
	
	  // placeholders in markdown for dynamic components
	  // const compiledSources = ReactServer.renderToStaticMarkup(<Leaderboard key={'1'} title={`Top Sources of ${name}`} items={topFoods} />);
	
	  var enhancedHTML = html.replace(/\$NAME/g, name);
	  // .replace('$SOURCES', compiledSources);
	
	  return _react2.default.createElement(
	    _NutrientTemplateStyles.StyledWrapper,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'What is ' + name + '?',
	      meta: [{ name: 'description', content: 'What is ' + name + '?' }, { name: 'keywords', content: name + ',' + tags + ',nutrient,health' }] }),
	    _react2.default.createElement(_Header2.default, { backLink: true }),
	    _react2.default.createElement(
	      _NutrientTemplateStyles.SpiceWrapper,
	      null,
	      _react2.default.createElement(_AnimatedIcons.MoleculeIcon, {
	        ringColor: 'black',
	        centerColor: 'black',
	        electronColor: 'black',
	        width: 50,
	        height: 50 })
	    ),
	    _react2.default.createElement(
	      _NutrientTemplateStyles.ContentWrapper,
	      null,
	      _react2.default.createElement(_NutrientTemplateStyles.MarkdownWrapper, { className: 'content--markdown', dangerouslySetInnerHTML: { __html: enhancedHTML } }),
	      _react2.default.createElement(
	        _NutrientTemplateStyles.SideWrapper,
	        null,
	        topFoods && _react2.default.createElement(_Leaderboard2.default, {
	          collapseAfter: 25,
	          key: '1',
	          title: 'Top Sources of ' + name + ' (per serving)',
	          description: 'Here are some foods rich in ' + name + '. (1\u03BCg is 0.001mg)',
	          items: topFoods })
	      )
	    )
	  );
	}
	
	// Styles
	;
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BackLinkWrap = exports.HeaderSection = exports.MarkdownWrapper = exports.SideWrapper = exports.SpiceWrapper = exports.ContentWrapper = exports.StyledWrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 0 0 4rem 0;\n  background: white;\n\n  > section {\n    padding: 1rem 2rem;\n  }\n'], ['\n  padding: 0 0 4rem 0;\n  background: white;\n\n  > section {\n    padding: 1rem 2rem;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  ', '\n'], ['\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  ', '\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['flex-direction: row;'], ['flex-direction: row;']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  margin: 2rem 0 0;\n'], ['\n  margin: 2rem 0 0;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  ', '\n'], ['\n  width: 100%;\n  ', '\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['width: 35%;'], ['width: 35%;']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  padding-right: 0;\n  ', '\n'], ['\n  width: 100%;\n  padding-right: 0;\n  ', '\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n    width: 65%;\n    padding-right: 4rem;\n  '], ['\n    width: 65%;\n    padding-right: 4rem;\n  ']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  padding: 8rem 1rem;\n  margin: 5rem 0 4rem 0;\n  position: relative;\n'], ['\n  padding: 8rem 1rem;\n  margin: 5rem 0 4rem 0;\n  position: relative;\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  display: block;\n  width: 100px;\n  font-size: 2rem;\n  line-height: 2rem;\n  padding: 1rem;\n  top: -5rem;\n  left: 0;\n  border-bottom: 1px solid black;\n\n  > a {\n    color: black;\n  }\n'], ['\n  position: absolute;\n  display: block;\n  width: 100px;\n  font-size: 2rem;\n  line-height: 2rem;\n  padding: 1rem;\n  top: -5rem;\n  left: 0;\n  border-bottom: 1px solid black;\n\n  > a {\n    color: black;\n  }\n']);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styleUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledWrapper = exports.StyledWrapper = _styledComponents2.default.div(_templateObject);
	
	var ContentWrapper = exports.ContentWrapper = _styledComponents2.default.section(_templateObject2, _styleUtils.media.fromMedium(_templateObject3));
	
	var SpiceWrapper = exports.SpiceWrapper = _styledComponents2.default.section(_templateObject4);
	
	var SideWrapper = exports.SideWrapper = _styledComponents2.default.section(_templateObject5, _styleUtils.media.fromMedium(_templateObject6));
	var MarkdownWrapper = exports.MarkdownWrapper = _styledComponents2.default.section(_templateObject7, _styleUtils.media.fromMedium(_templateObject8));
	
	var HeaderSection = exports.HeaderSection = _styledComponents2.default.section(_templateObject9);
	
	var BackLinkWrap = exports.BackLinkWrap = _styledComponents2.default.div(_templateObject10);

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-nutrient-template-nutrient-template-js-4c27459754848d1811fc.js